module.exports = __webpack_public_path__ + "img/SR_ICON_Aufgaben.1be1c271.svg";